/*
  Rebel Athletic — refresh the cart UI after a back/forward (bfcache) restore.
  -------------------------------------------------------------------------
  When a shopper adds to cart, then taps the browser Back button to return to
  a collection, the browser may restore that page from its back/forward cache
  (bfcache): a frozen snapshot taken BEFORE the add. The page's header cart
  count is therefore stale (shows the old quantity), which looks like the item
  was removed — even though the server cart (/cart.js) still has every item.

  This is a DISPLAY bug, not real cart loss. On a bfcache restore we re-sync the
  UI by dispatching the theme's own cart-refresh event, which re-fetches the
  cart from the server and updates the header count + quick-cart drawer.

  SAFE / ADDITIVE: only runs on bfcache restore (event.persisted === true);
  fails open (wrapped in try/catch); no effect on normal navigation.
*/
(function () {
  'use strict';
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return; // only bfcache (back/forward) restores
    try {
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
    } catch (e) {
      /* no-op: never break the page over a cart-count refresh */
    }
  });
})();
